export const CURRENCY_FORMATS = {
  cl: {
    locale: 'es-CL',
    options: {
      style: 'currency',
      currency: 'CLP',
    },
  },
  pe: {
    locale: 'es-PE',
    options: {
      style: 'currency',
      currency: 'PEN',
    },
  },
};
